'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getSvgControls = exports.getSvgControls = function getSvgControls() {
    if (process.env.IS_WEB) {
        return {
            Svg: 'svg',
            Circle: 'circle',
            Ellipse: 'ellipse',
            G: 'g',
            LinearGradient: 'linearGradient',
            RadialGradient: 'radialGradient',
            Line: 'line',
            Path: 'path',
            Polygon: 'polygon',
            Polyline: 'polyline',
            Rect: 'rect',
            Symbol: 'symbol',
            Use: 'use',
            Defs: 'defs',
            Stop: 'stop'
        };
    } else {
        var _require = require('react-native-svg'),
            Svg = _require.Svg,
            Circle = _require.Circle,
            Ellipse = _require.Ellipse,
            G = _require.G,
            LinearGradient = _require.LinearGradient,
            RadialGradient = _require.RadialGradient,
            Line = _require.Line,
            Path = _require.Path,
            Polygon = _require.Polygon,
            Polyline = _require.Polyline,
            Rect = _require.Rect,
            _Symbol = _require.Symbol,
            Use = _require.Use,
            Defs = _require.Defs,
            Stop = _require.Stop;

        return {
            Svg: Svg,
            Circle: Circle,
            Ellipse: Ellipse,
            G: G,
            LinearGradient: LinearGradient,
            RadialGradient: RadialGradient,
            Line: Line,
            Path: Path,
            Polygon: Polygon,
            Polyline: Polyline,
            Rect: Rect,
            Symbol: _Symbol,
            Use: Use,
            Defs: Defs,
            Stop: Stop
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/utils/svg.utils.js
// module id = 4
// module chunks = 0